import { getRequest, putRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getHardwareApprovalList = async (pageNo = 0, pageSize = 10) => {
  try {
    return await getRequest(`${urls.WT_HARDWARE_APPROVAL_LIST}?pagenum=${pageNo}&pagesize=${pageSize}`);
  } catch (err) {
    return err;
  }
};

export const updateHardwareApprovalAssignees = async (payload) => {
  try {
    return await putRequest(`${urls.WT_HARDWARE_APPROVAL_LIST}/assignees`, payload);
  } catch (err) {
    return err;
  }
};

export const getHardwareApprovalByRequestId = async (requestId) => {
  try {
    return await getRequest(urls.WT_HARDWARE_APPROVAL_LIST + `/${requestId}`);
  } catch (err) {
    return err;
  }
};

export const getMyHardwareApprovalRequests = async (assignee, pageNo = 0, pageSize = 10) => {
  try {
    return await getRequest(`${urls.WT_HARDWARE_APPROVAL_LIST}?assignee=${encodeURIComponent(assignee)}&pagenum=${pageNo}&pagesize=${pageSize}`);
  } catch (err) {
    return err;
  }
};

export const getHardwareApprovalrequest = async (pageNo = 0, pageSize = 1, hwreqid = hwreqid) => {
  try {
    return await getRequest(`${urls.WT_HARDWARE_APPROVAL_LIST}?pagenum=${pageNo}&pagesize=${pageSize}&hwreqid=${hwreqid}`);
  } catch (err) {
    return err;
  }
};

export const navigateToCSPOrder = (cspId) => {
  if (cspId && String(cspId).trim() !== "") {
    let url = "";
    if (process.env.REACT_APP_ENV === "qa") {
      url = urls.CSP_URL_QA + cspId + "/view";
    } else if (process.env.REACT_APP_ENV === "prod") {
      url = urls.CSP_URL_PROD + cspId + "/view";
    } else if (process.env.REACT_APP_ENV === "UAT") {
      url = urls.CSP_URL_UAT + cspId + "/view";
    } else {
      url = urls.CSP_URL_QA + cspId + "/view";
    }
    window.open(url, "_blank");
  }
};
